import { autorun } from 'mobx';
import { onPatch } from 'mobx-state-tree';
import createModel from './createModel';
export default function createViewState(opts) {
    const { assembly, tracks, internetAccounts, configuration, aggregateTextSearchAdapters, plugins, hydrateFn, createRootFn, makeWorkerInstance, onChange, } = opts;
    const { model, pluginManager } = createModel(plugins || [], makeWorkerInstance, hydrateFn, createRootFn);
    let { defaultSession } = opts;
    if (!defaultSession) {
        defaultSession = {
            name: 'this session',
            view: {
                id: 'circularView',
                type: 'CircularView',
            },
        };
    }
    const stateSnapshot = {
        config: {
            configuration,
            assembly,
            tracks,
            internetAccounts,
            aggregateTextSearchAdapters,
            defaultSession,
        },
        session: defaultSession,
    };
    const stateTree = model.create(stateSnapshot, { pluginManager });
    stateTree.config.internetAccounts.forEach(account => {
        const internetAccountType = pluginManager.getInternetAccountType(account.type);
        if (!internetAccountType) {
            throw new Error(`unknown internet account type ${account.type}`);
        }
        stateTree.addInternetAccount({
            type: account.type,
            configuration: account,
        });
    });
    pluginManager.setRootModel(stateTree);
    pluginManager.configure();
    autorun(reaction => {
        var _a;
        const { session, assemblyManager } = stateTree;
        if (!session.view.initialized) {
            return;
        }
        const regions = (_a = assemblyManager.get(assembly === null || assembly === void 0 ? void 0 : assembly.name)) === null || _a === void 0 ? void 0 : _a.regions;
        if (!regions) {
            return;
        }
        session.view.setDisplayedRegions(regions);
        reaction.dispose();
    });
    if (onChange) {
        onPatch(stateTree, onChange);
    }
    return stateTree;
}
